import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import styles from './Loading.module.scss';

const variants = {
    compact: styles.compact,
    xs: styles.xs,
    default: ''
};
const Loading = ({ message, variant, ...props }) => {
    const intl = useIntl();

    const containerClassName = [styles.container, variants[variant]].filter(Boolean).join(' ');

    return (
        <div
            data-testid={props['data-testid']}
            className={containerClassName}
        >
            <h2 className={message || 'govuk-visually-hidden'} data-testid={`${props['data-testid']}-title`}>{message || intl.formatMessage({ id: 'Loading.title' })}</h2>
            <div className={styles.loader} />
        </div>
    );
};

Loading.propTypes = {
    message: PropTypes.string,
    variant: PropTypes.oneOf(['default', 'compact', 'xs']),
    'data-testid': PropTypes.string
};

export default Loading;
